import React from 'react';

import { useTranslation } from 'react-i18next';

import Paginator from 'components/application/Paginator';
import Table from 'components/application/Table';

import TrainingEventRow from 'components/trainingEvents/TrainingEventRow';

export default function TrainingEventsTab({
  fetchPersonnelEvents,
  metaData,
  personnelEvents,
  profilePhotos,
  users,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const handlePageChange = (event) => {
    const page = event.currentTarget.getAttribute('data-page');
    fetchPersonnelEvents(page);
  };

  const triggererInitialsAndPhoto = (event) => {
    if (event.attributes.activity.includes('via_api')) {
      return { initials: i18nTShared('api'), userPhotoPath: null };
    }

    const isNadminInitiated = !!event?.relationships?.nadminUser?.data?.id;

    const triggerUser =
      event?.relationships?.triggerer?.data?.id ?
        users[event.relationships.triggerer.data.id]
      : null;

    const initials =
      triggerUser ?
        `${triggerUser.attributes.firstName[0]}${triggerUser.attributes.lastName[0]}`
      : null;

    const triggerUserPhoto =
      triggerUser ?
        Object.values(profilePhotos).find(
          (profilePhoto) =>
            profilePhoto.relationships?.personnel?.data?.id ===
              triggerUser.relationships?.personnel?.data?.id &&
            profilePhoto.type === 'profilePhoto',
        )
      : null;

    const userPhotoPath = triggerUserPhoto?.links?.croppedUrl;

    return { initials, isNadminInitiated, userPhotoPath };
  };

  return (
    <>
      <Table
        headers={
          <tr>
            <th className='tw-w-[30%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
              {i18nTShared('date')}
            </th>
            <th className='tw-w-[70%] tw-pl-12 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
              {i18nTShared('change')}
            </th>
          </tr>
        }
        rows={personnelEvents.map((event, index) => {
          const { initials, isNadminInitiated, userPhotoPath } =
            triggererInitialsAndPhoto(event);
          return (
            <TrainingEventRow
              isNadminInitiated={isNadminInitiated}
              key={index}
              personnelEvent={event.attributes}
              userInitials={initials}
              userPhotoPath={userPhotoPath}
            />
          );
        })}
      />
      {metaData.totalPages > 1 && (
        <div className='tw-mt-20 tw-text-center'>
          <Paginator
            currentPage={metaData.currentPage}
            onClick={handlePageChange}
            totalPages={metaData.totalPages}
          />
        </div>
      )}
    </>
  );
}
